import { Button } from "@/components/ui/button";

interface LanguageToggleProps {
  currentLanguage: 'en' | 'de';
  onLanguageChange: (language: 'en' | 'de') => void;
}

const LanguageToggle = ({ currentLanguage, onLanguageChange }: LanguageToggleProps) => {
  return (
    <div
      className="flex items-center gap-2 bg-card/50 backdrop-blur-sm rounded-lg p-1 border border-primary/20"
      role="group"
      aria-label="Language selection"
    >
      <Button
        variant={currentLanguage === 'en' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onLanguageChange('en')}
        className="transition-all duration-200"
        aria-pressed={currentLanguage === 'en'}
      >
        English
      </Button>
      <Button
        variant={currentLanguage === 'de' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onLanguageChange('de')}
        className="transition-all duration-200"
        aria-pressed={currentLanguage === 'de'}
      >
        Deutsch
      </Button>
    </div>
  );
};

export default LanguageToggle;
